import { createFileRoute } from '@tanstack/react-router';

import { DomainsPage } from '../features/supply/domains/DomainsPage';
import { domainsRouteSearchSchema } from '../features/supply/domains/domainsRouteSearch';

export const Route = createFileRoute('/supply/domains')({
  validateSearch: domainsRouteSearchSchema,
  component: DomainsPage,
});
